import React, { useReducer } from "react";
import Context from "./Context";
import Reducer from "./reducer";
import {
  SET_ALL_NODES,
  SET_HOVERED_NODES,
  SET_AUTHENTICATION,
  SET_ALL_EDGES,
  SET_ERROR_NODES,
  SET_API_KEY,
  SET_CURRENT_PLAN
} from "./action";
export const State = (props) => {
  const initialState = {
    allNodes: [],
    allEdges: [],
    hoveredNode:[],
    erroredNode:[],
    authenticate:false,
    api_keyValue: '',
    currentPlan:[],
  };

  const [state, dispatch] = useReducer(Reducer, initialState);
  const setAllNodes = (nodes) => {
    dispatch({
      type: SET_ALL_NODES,
      payload: nodes,
    });
  };
  const setAllEdges = (edges) => {
    dispatch({
      type: SET_ALL_EDGES,
      payload: edges,
    });
  };
  const setHoveredNode = (node) => {
    dispatch({
      type: SET_HOVERED_NODES,
      payload: node,
    });
  };
  const setErroredNode = (node) => {
    dispatch({
      type: SET_ERROR_NODES,
      payload: node,
    });
  };
  const setAuthenticate = (value) => {
    dispatch({
      type: SET_AUTHENTICATION,
      payload: value,
    });
  };

  const setUserPlanInformation = (value) => {
    dispatch({
      type: SET_API_KEY,
      payload: value,
    });
  }
  const setCurrentPlan = (value) => {
    dispatch({
      type: SET_CURRENT_PLAN,
      payload: value,
    });
  }

  return (
    <Context.Provider
      value={{
        allNodes: state.allNodes,
        hoveredNode: state.hoveredNode,
        authenticate: state.authenticate,
        allEdges: state.allEdges,
        erroredNode: state.erroredNode,
        api_keyValue:state.api_keyValue,
        currentPlan:state.currentPlan,
        setAllNodes,
        setHoveredNode,
        setAuthenticate,
        setAllEdges,
        setErroredNode,
        setUserPlanInformation,
        setCurrentPlan
      }}
    >
      {props.children}
    </Context.Provider>
  );
};
